import { useTheme } from "@fluentui/react";

import {
  ITermLogs,
  TermActionTranslate,
  TermsActionsLogsTypeDotColor
} from "./TermLogs.interfaces";

import { SharedLogRow } from "@/components/Shared/LogRow";

interface LogRowProps {
  log: ITermLogs;
}

function LogRow({ log }: LogRowProps) {
  const theme = useTheme();

  return (
    <SharedLogRow
      iconColor={
        TermsActionsLogsTypeDotColor[log.logType] ||
        theme.palette.neutralSecondary
      }
      title={TermActionTranslate[log.logType]}
      statusChangeReason={log.statusChangeReason}
      currentStep={log.currentStep}
      nextStep={log.nextStep}
      user={log.user}
      createdAt={log.createdAt}
    />
  );
}

export default LogRow;
